/* eslint-disable max-lines */
/* eslint-disable max-len */
import styled from 'styled-components/macro';
import iconClear from 'images/icons-lucy4/input-icons/times-inputs.svg';
import nextArrow from 'images/lucy4/arrow-next.svg';
import previousArrow from 'images/lucy4/arrow-previous.svg';
import { fontWeightPalette } from 'utils/styleConstants';

export const Relative = styled.div`
  position: relative;
`;

export const StyledInputWrapper = styled.div<{
  inputWidth?: string;
  fontColor?: string;
  height?: string;
  small?: boolean;
  backgroundColor?: string;
  borderRadius?: string;
  paddingLeft?: string;
  hasFeedback?: boolean;
  noBorder?: boolean;
  feedbackColor?: string;
  isOpen?: boolean;
  inputHeight?: string;
}>`
  border: none;
  .react-datepicker-wrapper {
    width: 100% !important;
  }
  .react-datepicker__input-container {
    border: 0;
    width: fit-content;
    &:hover {
      border: 0;
    }

    input {
      font-family: ${({ theme }) => theme.fontFamily};
      width: ${({ inputWidth }) => inputWidth ?? '100%'};
      color: ${({ fontColor, theme }) =>
        fontColor || (theme?.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9)};
      height: ${({ height, small }) => height ?? (small ? '20px' : '30px')};
      background-color: ${({ backgroundColor, theme }) =>
        backgroundColor ?? (theme?.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white)};
      border-radius: ${({ borderRadius, small }) => (borderRadius ? `${borderRadius}` : small ? '9px' : '3px')};
      font-weight: ${({ small }) => (small ? fontWeightPalette.light : fontWeightPalette.regular)};
      padding-left: ${({ paddingLeft }) => paddingLeft ?? '10px'};
      font-size: ${({ theme }) => theme.fontSizePalette.small};
      border: none !important;
      outline: ${({ hasFeedback, noBorder, feedbackColor, theme, small, isOpen }) =>
        hasFeedback
          ? `1px solid ${feedbackColor ?? theme?.statusColors.error}`
          : noBorder
          ? 'none'
          : isOpen
          ? `1px solid ${
              theme?.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark
            }`
          : `1px solid ${
              small
                ? theme?.colorPalette.isDarkMode
                  ? theme.colorPalette.grey.grey3
                  : theme.colorPalette.grey.grey2
                : theme?.colorPalette.isDarkMode
                ? theme.colorPalette.grey.grey3
                : theme.colorPalette.grey.grey5
            }`};

      &:focus-visible {
        outline-width: 1px;
        border: 0;
        outline: ${({ hasFeedback, noBorder, feedbackColor, theme, small, isOpen }) =>
          hasFeedback
            ? `1px solid ${feedbackColor ?? theme?.statusColors.error}`
            : noBorder
            ? 'none'
            : isOpen
            ? `1px solid ${
                theme?.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark
              }`
            : `1px solid ${
                small
                  ? theme?.colorPalette.isDarkMode
                    ? theme.colorPalette.grey.grey3
                    : theme.colorPalette.grey.grey2
                  : theme?.colorPalette.isDarkMode
                  ? theme.colorPalette.grey.grey3
                  : theme.colorPalette.grey.grey5
              }`};
      }

      &:hover {
        border: 0;
      }

      &:disabled {
        outline: ${({ theme }) =>
          theme.colorPalette.isDarkMode ? 'none' : `1px solid ${theme.colorPalette.grey.grey5}`}!important;
        color: ${({ theme }) =>
          theme.colorPalette.isDarkMode ? theme.colorPalette.black : theme.colorPalette.grey.grey7}!important;
        background-color: ${({ theme }) =>
          theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey1 : theme.colorPalette.grey.grey1}!important;
        opacity: 0.7;
      }
    }
  }
  div {
    .react-datepicker__close-icon {
      &:after {
        background-color: transparent;
        color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey8 : 'grey')};
        content: url(${iconClear});
        width: 16px;
        height: 16px;
        right: 10px;
      }
    }
  }
`;

export const StyleWrapper = styled.div<{ hasQuickRangeButtons?: boolean }>`
  /* Base styles */
  div {
    font-family: ${({ theme }) => theme.fontFamily};
    font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  }

  /* Main datepicker container */
  .react-datepicker {
    border: 1px solid
      ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey3 : theme.colorPalette.white};
    border-radius: 8px;
  }

  .react-datepicker-popper {
    z-index: 100 !important;
  }

  /* Header styles */
  .react-datepicker__header {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey3 : theme.colorPalette.white};
    border: 0;
    padding: 0;
  }

  .react-datepicker__current-month {
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey7};
    font-size: ${({ theme }) => theme.fontSizePalette.large};
    margin-bottom: 10px;
  }

  /* Navigation styles */
  .react-datepicker__navigation {
    margin-top: 8px;
  }

  .react-datepicker__navigation--next {
    background: url(${nextArrow}) no-repeat;
    width: 16px;
    height: 16px;
    border: none;
    filter: ${({ theme }) => (theme.colorPalette.isDarkMode ? 'brightness(2.5)' : 'none')};

    span {
      display: none !important;
    }
  }

  .react-datepicker__navigation--previous {
    background: url(${previousArrow}) no-repeat;
    width: 16px;
    height: 16px;
    border: none;
    filter: ${({ theme }) => (theme.colorPalette.isDarkMode ? 'brightness(2.5)' : 'none')};

    span {
      display: none !important;
    }
  }

  /* Day names */
  .react-datepicker__day-names {
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey8 : theme.colorPalette.grey.grey9};
    margin: 8px 0 0 0;
    padding-left: 4px;
  }

  .react-datepicker__day-name {
    font-size: ${({ theme }) => theme.fontSizePalette.small};
    font-weight: 500;
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
  }

  /* Day styles */
  .react-datepicker__day {
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSizePalette.small};
    &:hover {
      border-radius: 1.3em;
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
    }
  }

  .react-datepicker__day--selected {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white)};
    border-radius: 1.3em;
    font-weight: 500;
    &:hover {
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    }
  }
  .react-datepicker__day--today:not(.react-datepicker__day--selected) {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.light : theme.colorPalette.turquoise.accent2};
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey1 : theme.colorPalette.grey.grey9};
    border-radius: 1.3em;
  }

  .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--today) {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey3 : theme.colorPalette.white};
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey9 : theme.colorPalette.grey.grey10};
    border-radius: 1.3em;
    &:hover {
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    }
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? '#8c8d8e !important' : theme.colorPalette.grey.grey5)};
    opacity: 0.65;
    &:hover {
      color: ${({ theme }) => (theme.colorPalette.isDarkMode ? '#3C3D3F !important' : theme.colorPalette.grey.grey5)};
    }
  }

  .react-datepicker__day--in-range {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.dark15 : theme.colorPalette.turquoise.dark15};
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.turquoise.normal};
    border-radius: 1.3em;
  }

  .react-datepicker__day--in-selecting-range {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.dark15 : theme.colorPalette.turquoise.dark15};
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.turquoise.normal};
    border-radius: 1.3em;
    &:hover {
      border-radius: 1.3em;
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
    }
  }

  .react-datepicker__day--selected.react-datepicker__day--in-selecting-range {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white)};
    border-radius: 1.3em;
    &:hover {
      border-radius: 1.3em;
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
    }
  }

  .react-datepicker__day--range-end,
  .react-datepicker__day--range-start {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode
        ? theme.colorPalette.turquoise.accent
        : theme.colorPalette.turquoise.dark} !important;
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white} !important;
    border-radius: 1.3em;
    font-weight: 500;
  }
  .react-datepicker__day--keyboard-selected.react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white)};
    border-radius: 1.3em;
  }

  /* Week styles */
  .react-datepicker__week {
    font-size: ${({ theme }) => theme.fontSizePalette.medium};
    font-weight: ${({ theme }) => theme.fontWeightPalette.regular};
  }

  /* Month container */
  .react-datepicker__month {
    height: 200px;
    width: 236px;
    min-width: 236px;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    align-content: stretch;
    padding-left: 4px;
  }

  .react-datepicker__month {
    height: 170px;
    width: 236px;
    min-width: 236px;
  }
  /* Year and Month picker containers */
  .react-datepicker__year-wrapper,
  .react-datepicker__monthPicker {
    height: 200px;
    width: 236px;
    min-width: 236px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  .react-datepicker__year-wrapper {
    flex-direction: row;
  }

  .react-datepicker__year {
    margin: 0;
  }

  .react-datepicker__year--container,
  .react-datepicker__month-container {
    padding: 16px;
    border-radius: 11px;
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey3 : theme.colorPalette.white};
  }

  /* Month and Year text styles */
  .react-datepicker__year-text,
  .react-datepicker__month-text {
    display: inline-block;
    width: 4rem;
    margin: 0 6px;
    height: 18px;
    text-align: center;
    padding: 2px;
    border-radius: 10px;
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
    font-size: ${({ theme }) => theme.fontSizePalette.medium};
    font-weight: 400;
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.light : theme.colorPalette.turquoise.dark15};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.grey.grey9};
    }
  }

  .react-datepicker__year-text {
    margin: 0;
  }

  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white)};
    font-weight: 500;
    &:hover {
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
    }
  }

  .react-datepicker__month-text,
  .react-datepicker__year-text {
    font-size: 16px;
    padding: 4px 0;
    height: 24px;
    width: 64px;
    border-radius: 16px;
    font-weight: 400;
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey3 : theme.colorPalette.white};
    color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9};
    &:hover {
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
    }
  }

  .react-datepicker__month-text--selected,
  .react-datepicker__year-text--selected {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => (theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white)};
    font-weight: 500;
    &:hover {
      background-color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white};
    }
  }
  .react-datepicker__year-text--disabled {
    opacity: 0.5;
    &:hover {
      background-color: transparent !important;
      color: ${({ theme }) =>
        theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.grey.grey9} !important;
    }
  }
  .react-datepicker__week {
    height: 28px;
  }
  .react-datepicker__day {
    margin: 5px;
  }
  .react-datepicker__day-name {
    margin: 5px 5px 0 5px;
  }
`;

export const NavigationButton = styled.button<{ disabled?: boolean }>`
  border: none;
  background: transparent;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 0.7)};
  }
`;
